import React, {Component} from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import Button from '@adsk/bim360-matrix-react-button';
import Text from '@adsk/bim360-matrix-react-text';

/**
 * @TryAgainErrorNotification
 */
class TryAgainErrorNotification extends Component {
  /**
   * render
   */
  render() {
    const {message, tryAgainAction} = this.props;

    return (
      <div className="TryAgainErrorNotification">
        <Text hasHTML>{message}</Text>
        <Button
          className="TryAgainErrorNotification__link"
          styleType={Button.StyleType.INLINE_LINK}
          onClick={() => tryAgainAction()}
        >
          {i18n.t('notifications.tryAgain')}
        </Button>
      </div>
    );
  }
}

TryAgainErrorNotification.displayName = 'TryAgainErrorNotification';

TryAgainErrorNotification.propTypes = {
  message: PropTypes.node.isRequired,
  tryAgainAction: PropTypes.func.isRequired
};

export default TryAgainErrorNotification;
